var render = function render(){var _vm=this,_c=_vm._self._c;return _c('appInvoice',{attrs:{"company":_vm.company,"customer":_vm.customer,"invoice":_vm.invoice,"variant":1,"currency":"usd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }